// extracted by mini-css-extract-plugin
export default {"tags":"tags_tags__yvuZh","otherTag":"tags_otherTag__448Uh","appliedTag":"tags_appliedTag__D-iTf","grayAppliedTag":"tags_grayAppliedTag__UawDJ"};